import {
  differenceInCalendarDays,
  eachMonthOfInterval,
  format,
} from 'date-fns';
import { DateRange } from 'shared/types/date-range';

export type TimelineMonthDivider = {
  key: string;
  left: number;
};

export type GetTimelineMonthDividersOptions = {
  dateRange: DateRange;
  dayWidth: number;
};

// x-position of the 1st of each month across the range, for the Month timeframe
// (whose columns are weekly and don't mark month boundaries — unlike Quarter /
// Year, whose month columns already draw those lines).
export const getTimelineMonthDividers = ({
  dateRange,
  dayWidth,
}: GetTimelineMonthDividersOptions): TimelineMonthDivider[] => {
  if (dayWidth <= 0) {
    return [];
  }

  return eachMonthOfInterval({
    start: dateRange.startDate,
    end: dateRange.endDate,
  })
    .map((monthStart) => ({
      key: format(monthStart, 'yyyy-MM'),
      left:
        differenceInCalendarDays(monthStart, dateRange.startDate) * dayWidth,
    }))
    .filter(({ left }) => left >= 0);
};
